import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { signContractApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${signContractApiUrl()}/api`;

export default createScopedApi(BASE_API_URL, axiosInstance);
